import React, { useEffect, useState } from "react";
import { FileMusic, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const LessonScores = ({ lessonId, user }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    if (!user) { setItems([]); return; }
    api.get(`/lessons/${lessonId}/scores`).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [lessonId, user]);
  if (!items.length) return null;
  const open = async (x) => {
    const tab = window.open("", "_blank");
    setBusy(x.id);
    try {
      const res = await api.get(`/lesson-scores/${x.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      if (tab) tab.location.href = url; else window.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { tab?.close(); toast.error("Could not open the music"); }
    setBusy("");
  };
  return (
    <section className="mt-12 rounded-2xl border border-primary/30 bg-primary/5 p-5" data-testid="lesson-scores">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-primary"><FileMusic size={14} /> Music from Jason</p>
      <p className="mt-1 text-sm text-muted-foreground">Sheet music Jason has prepared for this lesson. It opens in a new tab, ready to print.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {items.map((x) => (
          <button key={x.id} type="button" onClick={() => open(x)} data-testid={`lesson-score-${x.id}`}
            className="inline-flex items-center gap-2 rounded-full border border-primary px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary hover:text-primary-foreground">
            {busy === x.id ? <Loader2 size={14} className="animate-spin" /> : <FileMusic size={14} />} {x.label} <span className="text-xs font-normal opacity-80">({x.written_key})</span>
          </button>
        ))}
      </div>
    </section>
  );
};
